import { Schema as S } from "effect";

/**
 * Prescription activity types supported by DocCirrus
 *
 * @since 1.0.0
 */
export const PrescriptionActType = S.Literals(
  ["PUBPRESCR",
  "PRIVPRESCR",
  "LONGPRESCR",
  "PRESCRBTM",
  "PRESCRG",
  "PRESCRT"]
);
export type PrescriptionActType = S.Schema.Type<typeof PrescriptionActType>;

/**
 * Request schema for listing patient prescriptions
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const req: ListPrescriptionsRequest = { patientId: "abc123" }
 * ```
 */
export const ListPrescriptionsRequestSchema = S.Struct({
  patientId: S.String,
  fromDate: S.optional(S.String),
  actTypes: S.optional(S.Array(PrescriptionActType)),
});

export type ListPrescriptionsRequest = S.Schema.Type<
  typeof ListPrescriptionsRequestSchema
>;
